import React, { useState } from 'react';
import FilterModalTemplate from './FilterModalTemplate';
import Animation from '../../../../common/animation';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as ChatActions from '../../../../../store/modules/chat/actions';
import { convertActiveTabInScreen } from '../../../../../store/modules/chat/functions';

import {
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from '@polichat/flamboyant';
import { useGlotaT } from 'src/hooks/useGlotaTranslation';

function TagsModal({
                     tags,
                     isTagsMenuOpen,
                     toggleFilterMenu,
                     activeFilters,
                     submitFilter,
                     loading,
                     clearFilter,
                     currentTabNavigation
                   }) {
  const filter_type_name = 'tags';
  const filter_title = useGlotaT('spa.details.filters.filterByTag');
  const filter_icon = 'poli-icon pi-tag-line';
  const currentScreen = convertActiveTabInScreen(currentTabNavigation);
  const selectTagText = useGlotaT('spa.details.filters.selectTag');
  const noTagsText = useGlotaT('spa.details.filters.noTags');

  let content;
  let tags_select = [];
  let enabled = true;

  function verifyCurrentFilter() {
    if (!activeFilters.length) {
      setFilter(null);
    }
  }


  const findCurrentTagFilter = () => {
    let active_filter = null;

    if (activeFilters.length) {
      activeFilters.forEach((filter) => {
        if (filter.type === filter_type_name) {
          active_filter = filter.tag_id;
        }
      });
    }

    return active_filter;
  };

  const [filter, setFilter] = useState(findCurrentTagFilter());
  const selectedTagName = tags.find((tag) => Number(tag.id) === Number(filter))?.name || '';

  const findName = (id) => {
    verifyCurrentFilter();
    const tag = tags.find((tag) => Number(tag.id) === Number(id));
    return tag?.name || '';
  };

  const onSubmitEvent = () => {
    const payload = { ...activeFilters };

    if (filter !== null && filter !== undefined) {
      const value = Number(filter);
      const name = findName(value);

      payload.tag = [
        {
          name: name,
          value: value,
        },
      ];

      submitFilter(payload, currentScreen);
    } else {
      payload.tag = [];
      clearFilter(payload);
    }

    toggleFilterMenu(filter_type_name);
  };

  const sortByName = (a, b) => a.name.localeCompare(b.name);

  if (tags && tags.length) {
    tags_select = tags.sort(sortByName).map((tag, index) => (
      <DropdownItem
        key={`${tag.id}-${index}`}
        value={tag.id}
        className="dropItem-filters"
        onClick={() => setFilter(tag.id)}
      >
        <span className="transfers-name">{tag.name}</span>
      </DropdownItem>
    ));

    content = (
      <UncontrolledDropdown className="dropDown-filters">
        <DropdownToggle
          color="neutral"
          caret
          id="selecttags"
          name="selecttags"
          className="total dropDownToggle-filters"
        >
          <span>
            {filter && selectedTagName
              ? selectedTagName
              : selectTagText}
          </span>
        </DropdownToggle>
        <DropdownMenu className="dropDownMenu-filters">
          {tags_select}
        </DropdownMenu>
      </UncontrolledDropdown>
    );

    enabled = true;
  } else {
    enabled = false;
    if (tags && tags.length === 0) {
      content = <span className="noTags">{noTagsText}</span>;
    } else {
      content = <Animation icon="loading" size="tiny" />;
    }
  }

  return (
    <FilterModalTemplate
      icon={filter_icon}
      title={filter_title}
      content={content}
      isOpen={isTagsMenuOpen}
      toggleEvent={() => toggleFilterMenu(filter_type_name)}
      onSubmit={onSubmitEvent}
      loading={loading}
      disabled={!enabled}
    />
  );
}

const mapStateToProps = (state) => ({
  tags: state.chat?.config?.general?.tags,
  isTagsMenuOpen: state.chat?.filters?.view?.isTagsMenuOpen,
  activeFilters: state.chat?.filters?.activeFilters,
  loading: state.chat?.filters?.loading,
  currentTabNavigation: state.chat?.config?.activeTabNavigation,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(ChatActions, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(TagsModal);
